import { render, staticRenderFns } from "./PoliciesTable.vue?vue&type=template&id=8e3b780c"
import script from "./PoliciesTable.vue?vue&type=script&lang=ts"
export * from "./PoliciesTable.vue?vue&type=script&lang=ts"
import style0 from "./PoliciesTable.vue?vue&type=style&index=0&id=8e3b780c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports